import classNames from 'classnames';
import Avatar from 'components/Avatar';
import Label from 'components/Label';
import React, { Component } from 'react';
import type { UserDropdownValue } from 'redux/selectors/users';
import styles from './UserSearchOption.module.scss';

interface Props {
  option: UserDropdownValue;
}

class UserSearchOption extends Component<Props> {
  render() {
    const { option } = this.props;

    return (
      <div className={styles.optionValue}>
        {!option.empty && (
          <div className={styles.iconWrapper}>
            <div className={styles.icon}>
              <Avatar
                shape="rounded"
                size="small"
                name={option.label}
                src={option.avatar}
                fallbackToInitials
                tooltip={false}
                className="fs-exclude"
              />
            </div>
          </div>
        )}
        <div className={classNames(styles.label, 'fs-mask')}>{option.label}</div>
        {option.deleted && (
          <div>
            <Label size="small" className={styles.statusLabel}>
              deleted
            </Label>
          </div>
        )}
      </div>
    );
  }
}

export default UserSearchOption;
